module.exports = __webpack_public_path__ + "07_long_yellow.d71a0a72.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/07_long_yellow.png
// module id = IpZK
// module chunks = 0